import { manualVcApi, manualVcKey } from './ManualVc.api'

export const manualVcWalletEvent = 'manual-vc:open-wallet'
export type SavedManualDraft = { amount: number; key: string; reference?: string; phone?: string }
const storageKey = (userId: string | number) => `manual-vc-draft:${userId}`
export function readManualDraft(userId: string | number): SavedManualDraft | undefined {
	try {
		return JSON.parse(sessionStorage.getItem(storageKey(userId)) || 'null') || undefined
	} catch {
		return undefined
	}
}
export function saveManualDraft(userId: string | number, draft: SavedManualDraft) {
	sessionStorage.setItem(storageKey(userId), JSON.stringify(draft))
}
export function clearManualDraft(userId: string | number) {
	sessionStorage.removeItem(storageKey(userId))
}
export async function prepareManualDraft(userId: string | number, amount: number) {
	const saved = readManualDraft(userId)
	const draft = saved?.amount === amount ? saved : { amount, key: manualVcKey() }
	saveManualDraft(userId, draft)
	const request = draft.reference ? await manualVcApi.detail(draft.reference) : await manualVcApi.create(amount, draft.key)
	if (request.status !== 'draft') {
		clearManualDraft(userId)
		return request
	}
	saveManualDraft(userId, { ...draft, reference: request.reference })
	return request
}
export function openManualWallet(amount?: number, reference?: string) {
	window.dispatchEvent(new CustomEvent(manualVcWalletEvent, { detail: { amount, reference } }))
}
